import { render, staticRenderFns } from "./MeasurementProgramStudent.vue?vue&type=template&id=c08be324&scoped=true"
import script from "./MeasurementProgramStudent.vue?vue&type=script&lang=js"
export * from "./MeasurementProgramStudent.vue?vue&type=script&lang=js"
import style0 from "./MeasurementProgramStudent.vue?vue&type=style&index=0&id=c08be324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08be324",
  null
  
)

export default component.exports